export default __webpack_public_path__ + "static/001-ee4f796c15c9cb9eff29d8380edab105.png";